import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LibConfiguration } from '../lib-configuration';
import { LIB_CONFIG } from '../lib-configuration-token';
import { UserSessionService } from './user-session.service';

@Injectable({
  providedIn: 'root',
})
export class APIService {
  private apiURL: string;
  constructor(
    private http: HttpClient,
    private userSessionService: UserSessionService,
    private toastr: ToastrService,
    private injector: Injector
  ) {
    this.apiURL = this.injector.get(LIB_CONFIG).apiUrl;
  }

  private handleError(error: HttpErrorResponse): Observable<any> {
    switch (error.status) {
      case 0:
        this.handleOfflineError(error);
      case 500:
        this.handleInternalError(error);
      case 403:
        this.handleForbiddenError(error);
    }

    return throwError(error);
  }

  /**
   * Handle internal errors (uncaught errors)
   * @param {HttpErrorResponse} error
   */
  private handleInternalError(error: HttpErrorResponse) {
    // show internal error popup
  }

  /**
   * Handle Offline Errors
   * @param {HttpErrorResponse} error
   */
  private handleOfflineError(error: HttpErrorResponse) {
    this.toastr.error('Nincs kapcsolat a szerverrel.');
  }

  /**
   * Handle Forbidden Errors
   * @param {HttpErrorResponse} error
   */
  private handleForbiddenError(error: HttpErrorResponse) {
    if (error.error.session !== localStorage.getItem('sessionId')) {
      this.userSessionService.delCurrentUser();
    } else {
      this.toastr.error(error.message);
    }
  }

  /**
   * Make get request
   * @param {string} resourceName
   * @param {Object} urlParams
   * @param {Object} requestBody
   */
  post(
    resourceName: string,
    urlParams?: Object,
    requestBody?: Object
  ) {
    const url = new URL(`${ this.apiURL }${ resourceName }`);
    if (urlParams) {
      for (const [key, value] of Object.entries(urlParams)) {
        url.searchParams.set(key, value);
      }
    }

    const currentSessionId = localStorage.getItem('sessionId');
    url.searchParams.set('session', currentSessionId);

    return this.http
      .post<Response>(url.toString(), requestBody)
      .pipe(catchError((error) => this.handleError(error)));
  }
}
